/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ retention: NonNullable<unknown>, view: NonNullable<unknown> }} Consumption_View_Too_OldInputs */



/**
* | output |
* | --- |
* | "This view keeps {retention} of data: use the {view} view or pick a more recent period." |
*
* @param {Consumption_View_Too_OldInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_view_too_old = /** @type {((inputs: Consumption_View_Too_OldInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_View_Too_OldInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`This view keeps ${i?.retention} of data: use the ${i?.view} view or pick a more recent period.`)
	return /** @type {LocalizedString} */ (`Données conservées ${i?.retention} pour cette vue : utilisez la vue ${i?.view} ou choisissez une période plus récente.`)
});